import { useState } from "react";
import { faqs } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-content mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10">
          <div className="lg:col-span-4">
            <SectionHeading
              kicker="FAQ"
              title="常见问题"
              desc="关于题材、内容形态与页面使用方式的常见疑问，先在这里找答案。展开任意一条即可阅读完整说明。"
            />
            <div className="mt-6 p-5 rounded-lg bg-secondary-50 border border-secondary-200">
              <i className="ri-question-answer-line text-xl text-secondary-700" />
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                没找到想问的？可以先看「读者讨论」区里其他人讨论得最多的话题，往往能覆盖大部分疑问。
              </p>
            </div>
          </div>

          <div className="lg:col-span-8 flex flex-col gap-3">
            {faqs.map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <div
                  key={item.q}
                  className={`rounded-lg border transition-colors ${
                    isOpen ? "bg-background-100 border-primary-300" : "bg-background-100 border-background-200"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    aria-expanded={isOpen}
                    className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                  >
                    <span className="font-heading text-base md:text-lg font-semibold text-foreground-950">
                      {item.q}
                    </span>
                    <span className={`w-7 h-7 shrink-0 rounded-full flex items-center justify-center ${isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"}`}>
                      <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
                    </span>
                  </button>
                  {isOpen ? (
                    <div className="px-5 pb-5 -mt-1">
                      <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                    </div>
                  ) : null}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}